import React from 'react';
import PropTypes from 'prop-types';

import {Avatar, Box, Typography, Paper} from 'views/components';
import {Translate} from 'views/module';
import {Person as PersonIcon} from 'views/icons';

const UserTile = (props) => {
  const {
    title,
    userData,
    nameField,
  } = props;


  const name = userData[nameField];
  const email = userData?.contacts?.Email?.detail;
  const phone = userData?.contacts?.['Phone number']?.detail;

  const profileImg = userData.profileImg;
  let isCaregiver = false;

  if (userData.caregiverRn) {
    isCaregiver = true;
  }

  return (
    <Paper sx={{border: '1px solid', borderColor: 'grey.200', borderRadius: 2, p: 2, flex: 1}}>
      <Box display="flex" alignItems="center" mb={2}>
        <PersonIcon sx={{mr: 1, color: 'grey.500', fontSize: 28, alignSelf: 'flex-start'}} />
        <Typography variant="subtitle2" sx={{fontWeight: 700, fontSize: 16, display: 'flex', alignItems: 'center', mb: 0}}>
          <Translate expression={title} />
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" mb={2}>
        {
        isCaregiver ? (
          <Box sx={{width: 60, height: 60, mr: 2, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Avatar
              sx={{width: 60, height: 60, mr: 2, fontWeight: 600}}
              alt={userData.caregiverName || name}
            >
              {(userData.caregiverName ? userData.caregiverName[0] : (name ? name[0] : 'C'))}
            </Avatar>
          </Box>
        ) : (
          <Avatar
            src={profileImg}
            alt={name}
            sx={{width: 60, height: 60, mr: 2, fontWeight: 600}}
          >
            {(!profileImg && name) ? name[0] : null}
          </Avatar>
        )
        }
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', height: 60, minWidth: 0}}>
          <Typography variant="body1" sx={{fontWeight: 600, lineHeight: 1.2}} noWrap>
            {name}
          </Typography>
          <Typography variant="body2" sx={{color: 'text.secondary', lineHeight: 1.2, minHeight: 20}} noWrap>
            {email ? email : <Translate expression="eventList.eventDetail.noEmail" />}
          </Typography>
          <Typography variant="body2" sx={{color: 'text.secondary', lineHeight: 1.2, minHeight: 20}} noWrap>
            {phone ? phone : <Translate expression="eventList.eventDetail.noPhone" />}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

UserTile.propTypes = {
  title: PropTypes.string.isRequired,
  userData: PropTypes.object,
  nameField: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  phoneField: PropTypes.string,
};

export default UserTile;
